import {
  aCategory,
  aSignalPage,
  mockSignalsQueryOperationQuery,
} from '__generated__';

import { SIGNAL_FRAGMENT } from '@sbu/configs.mocks';

export const handlers = [
  mockSignalsQueryOperationQuery((req, res, ctx) => {
    const query = req.variables.q;

    // Filtering by content type
    const contentType = query?.match(/contentType:"([^"]+)"/)?.[1];

    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        signals: {
          ...aSignalPage(),
          objects: [
            // @ts-ignore contentTypeEnum is aliased which causes issues with typing since MSW doesn't handle this case
            { ...SIGNAL_FRAGMENT, ...(contentType ? { contentType } : {}) },
          ],
        },
        categories: [aCategory()],
      })
    );
  }),
];
